import { render, staticRenderFns } from "./CustomerInsights.vue?vue&type=template&id=58584966&scoped=true"
import script from "./CustomerInsights.vue?vue&type=script&lang=js"
export * from "./CustomerInsights.vue?vue&type=script&lang=js"
import style0 from "./CustomerInsights.vue?vue&type=style&index=0&id=58584966&prod&lang=css"
import style1 from "./CustomerInsights.vue?vue&type=style&index=1&id=58584966&prod&scoped=true&lang=css"
import style2 from "./CustomerInsights.vue?vue&type=style&index=2&id=58584966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58584966",
  null
  
)

export default component.exports